import { Outlet, redirect, useRouteContext } from "@tanstack/react-router";
import { createFileRoute } from "@tanstack/react-router";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { identifyUser } from "@/analytics/auth";

export const Route = createFileRoute("/_logged")({
	component: RouteComponent,
	loader: ({ context }) => {
		if (!context.session?.isLoggedIn) {
			throw redirect({
				to: "/cadastro",
			});
		}
	},
	head: () => {
		return {
			meta: [
				{
					name: "robots",
					content: "noindex,nofollow",
				},
			],
		};
	},
});

function RouteComponent() {
	const posthog = usePostHog();
	const { session } = useRouteContext({ from: "__root__" });

	useEffect(() => {
		if (session?.isLoggedIn && session?.user) {
			identifyUser(posthog, session.user);
		}
	}, [session, posthog]);

	return <Outlet />;
}
